import '../scss/boiler-energylabel.scss';

const angular = require('angular');
const angularAnimate = require('angular-animate');

(function() {
    "use strict";
    var myApp = angular.module("ketelenergielabel", ['ngAnimate']);



     // Custom filter object to array
     myApp.filter('array', function( $filter ) {
        return function(items) {

            var filtered = [];

            angular.forEach(items, function(item) {
                filtered.push(item);
            });
            

            return filtered;
        };
    });



     myApp.controller("ketelenergielabel_controller", ['$scope', '$timeout', '$http', '$window' ,function($scope, $timeout, $http, $window) {

     	
        // Recive all boilers
        $scope.alleKetels = function() {
            $scope.allBoilers = {};

            var filterTypes = ['heating + hot water', 'only hot water', 'heat only', 'hybrid solutions'];

            $http({
                method: 'POST',
                url: '/wp-admin/admin-ajax.php',
                headers: {
                    'Content-Type': 'application/json'
                },
                params: {
                    action: 'Boilers', // (zie functions.php in root)
                    filter: filterTypes.toString(),
                    nonce: ajax_var.nonce,
                    function: 'allTypes',
                    uitsluitingen: $scope.uitsluitingen,
                    current_section: $scope.current_section

                }
            }).then(function(data) {
                $scope.allBoilers = data.data;

                console.info( 'allBoilers', data.data ) ;

                $timeout(function() {
                    $scope.appReady = {
                        opacity: 1,
                        transition: '0.5s'
                    };
                });
                
            });
        };

        $scope.alleThermostaten = function(){

            $scope.allThermostats = $window.json_str;

            // //var filterTypes = ['combi boiler', 'water heater',  'comfort product', 'hybrid boiler'];
            // var filterTypes = ['comfort product'];
            // $http({
            //     method: 'POST',
            //     url: '/wp-admin/admin-ajax.php',
            //     headers: {
            //         'Content-Type': 'application/json'
            //     },
            //     params: {
            //         action: 'Boilers', // (zie functions.php in root)
            //         filter: filterTypes.toString(),
            //         nonce: ajax_var.nonce,
            //         function: 'allTypes'
            //     }
            // }).then(function(data) {
            //     $scope.allThermostats = data.data;
            //     console.info( 'allThermostats', data.data ) ;
            //     $timeout(function() {
            //         $scope.appReady = {
            //             opacity: 1,
            //             transition: '0.5s'
            //         };
            //     });
            // });

        };



        $timeout(function() {
            $scope.alleKetels();
        });

        $scope.alleThermostaten();
        $scope.selectedBoilers = {};
        $scope.selectedThermostat = {};
        $scope.view = 'types';



        $scope.selectType = function(boiler){
            $scope.GroupTitle = boiler.title;
            $scope.relatedBoilers = boiler.related;
            $scope.viewSwitch('viewRelated');
        };



        // check all selected boilers
        $scope.selectBoiler = function(event, index, boiler) {
            $timeout(function() {
                
                angular.forEach( $scope.relatedBoilers , function(value, key) {
                    delete $scope.relatedBoilers[key].active;
                });

                boiler.active = true;
                $scope.selectedBoilers = boiler;
                $scope.selectedBoilerCount = Object.keys(  $scope.selectedBoilers  ).length; 
                //console.log($scope.selectedBoilers);

                $scope.viewSwitch('viewThermostats');
                

            });
        };

        
        // check all selected thermostats
        $scope.selectThermostat = function(event, index, thermostats) {
            $timeout(function() {

                angular.forEach( $scope.allThermostats , function(value, key) {
                    delete $scope.allThermostats[key].active;
                });

                thermostats.active = true;
                $scope.selectedThermostat = thermostats;

                $scope.selectedTHCount = Object.keys(  $scope.selectedThermostat  ).length; 

                //console.log($scope.selectedThermostat);
                $scope.viewSwitch('viewDownload');
            });
        };


        $scope.downloadLabel = function(){

            var productId = $scope.selectedBoilers.id;
            var tc = $scope.selectedThermostat.class;
            var tn = $scope.selectedThermostat.title;
            var product_title = $scope.selectedBoilers.title;
            
            if(window.open( ajax_var.theme_directory + '/energylabels/get-combi-energy-label.php?product-id='+productId+'&product_title='+product_title+'&tc='+tc+'&tn='+tn+'&nonce=' + ajax_var.nonce  , "_self")) {
                if(typeof Hooks === 'function') {
                    const hooks = new Hooks();
                    hooks.triggerAction('boilerEnergylabelDownloaded', [productId, product_title, tc, tn]);
                }
            }
            $scope.viewSwitch('viewDone');
            
        };




        $scope.viewSwitch = function(page){

            switch(page){

                case 'viewTypes':
                $scope.view = 'types';
                //console.log( 'viewTypes' );
                break;

                case 'viewRelated':
                $scope.view = 'related';
                //console.log( 'viewRelated' );
                break;

                case 'viewThermostats':
                $scope.view = 'thermostats';
                //console.log( 'thermostats' );
                break;

                case 'viewDownload':
                $scope.view = 'download';
                //console.log( 'download' );
                break;

                case 'viewDone':
                $scope.view = 'done';
                

                $timeout(function(){
                    $scope.viewSwitch('viewTypes');
                },3000);

                //console.log( 'done' );
                break;

            }

        };



    }]);









})();